import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/report/lihua",
    name: "report",
    component: (resolve) => require(["views/report.vue"], resolve),
  },
  {
    path: "/report/follower-page",
    name: "follower",
    component: (resolve) => require(["views/follower.vue"], resolve),
  },
  {
    path: "/report/task-order",
    name: "taskOrder",
    component: (resolve) => require(["views/task-order.vue"], resolve),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
